const SiteDesignPageLinkType = {
  External: "EXTERNAL",
  Internal: "INTERNAL"
};

export { SiteDesignPageLinkType };
//# sourceMappingURL=site-design-page-link-type.mjs.map
